<img src="assets/product-hero-header/ideal-100.svg" />
